// Authentication Models

export enum UserType {
  Unknown = 0,
  AppUser = 1,
  ServiceUser = 2,
  ApiUser = 3
}

export enum UserOrigin {
  Unknown = 0,
  Internal = 1,
  External = 2
}

export interface LoginRequest {
  userName: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  sessionId: string;
}

export interface RefreshTokenRequest {
  refreshToken: string;
}

export interface RefreshTokenResponse {
  accessToken: string;
}

export interface SignOutRequest {
  sessionId: string;
  userId?: string;
}

// ── Donor User API (Company API) ─────────────────────────────────────────────

/** POST /api/DonorUsers — register a new donor user */
export interface CreateDonorUserRequest {
  companyId: number;
  phoneNumber: string;
  email?: string;
  firstName?: string;
  lastName?: string;
}

/** Response for POST /api/DonorUsers */
export interface DonorUserResponse {
  id: number;
  phoneNumber: string;
  email: string;
  firstName?: string;
  lastName?: string;
}

/** POST /api/DonorUsers/SignIn */
export interface DonorUserSignInRequest {
  phoneNumber: string;
  password: string;
}

/** Response for POST /api/DonorUsers/SignIn */
export interface SignInResponse {
  accessToken: string;
  refreshToken: string;
  sessionId: string;
}

/** POST /api/DonorUsers/SignOut */
export interface DonorUserSignOutRequest {
  sessionId: string;
}

export interface UserInfo {
  userId: string;
  companyId: string;
  email: string;
  fullName: string;
  roles: string[];
  phoneNumber?: string;
  mustChangePassword?: string;
  userType?: string;
  userOrigin?: string;
  timezoneCode?: string;
  exp: number;
  iat: number;
  nbf: number;
  iss: string;
}

export interface DecodedToken {
  exp?: number;
  iat?: number;
  nbf?: number;
  iss?: string;
  aud?: string | string[];
  sub?: string;
  'custom:userid'?: string;
  'custom:companyid'?: string;
  'custom:email'?: string;
  'custom:fullname'?: string;
  'custom:role'?: string | string[];
  'custom:phonenumber'?: string;
  'custom:mustchangepasswordonlogin'?: string;
  'custom:usertype'?: string;
  'custom:userorigin'?: string;
  'custom:timezonecode'?: string;
}
